import Vue from 'vue'
import Router from 'vue-router'
import DonationIndex from '@/components/DonationIndex'
import DonationStepTwo from '@/components/DonationStepTwo'
import axios from 'axios'
import VModal from 'vue-js-modal'
import Login from '@/components/Login'
import Register from '@/components/Register'

Vue.use(Router)
Vue.use(VModal, {dialog: true})
Vue.prototype.$http = axios

export default new Router({
  routes: [
    {
      path: '/',
      name: 'stepone',
      components: {
        default: DonationIndex,
        index: DonationIndex
      }
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/steptwo',
      name: 'steptwo',
      components: {
        default: DonationStepTwo
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js